import toast from 'react-hot-toast'
import { HowIEatAchievement, HowIEatMealItem } from '../types/howIEat'

export function computeFastingProgress(startedAt: string, targetHours: number) {
  const elapsedMs = Date.now() - new Date(startedAt).getTime()
  const elapsedHours = elapsedMs / (1000 * 60 * 60)
  const remainingHours = Math.max(0, targetHours - elapsedHours)
  return {
    elapsedHours: Math.round(elapsedHours * 10) / 10,
    remainingHours: Math.round(remainingHours * 10) / 10,
    progressPct: Math.min(100, Math.round((elapsedHours / targetHours) * 100)),
    goalReached: elapsedHours >= targetHours,
  }
}

export function formatFastingDuration(hours: number) {
  const h = Math.floor(hours)
  const m = Math.round((hours - h) * 60)
  if (h > 0 && m > 0) return `${h}h ${m}m`
  if (h > 0) return `${h}h`
  return `${m}m`
}

export function templateTotals(items: HowIEatMealItem[]) {
  return items.reduce(
    (acc, i) => ({
      calories: acc.calories + (Number(i.calories) || 0),
      proteinG: acc.proteinG + (Number(i.proteinG) || 0),
      carbsG: acc.carbsG + (Number(i.carbsG) || 0),
      fatsG: acc.fatsG + (Number(i.fatsG) || 0),
    }),
    { calories: 0, proteinG: 0, carbsG: 0, fatsG: 0 },
  )
}

export function toastNewAchievements(before: HowIEatAchievement[], after: HowIEatAchievement[]) {
  for (const a of after) {
    if (a.unlocked && !before.find((b) => b.key === a.key && b.unlocked)) {
      toast.success(`${a.icon} ${a.title} unlocked!`, { duration: 4000 })
    }
  }
}

export async function checkAchievements(
  fetchAchievements: () => Promise<HowIEatAchievement[]>,
  previous: HowIEatAchievement[],
) {
  const next = await fetchAchievements()
  toastNewAchievements(previous, next)
  return next
}
